import request from "@/utils/request";

export function getFileContentByPath(filePath) {
  return request({
    url: "/bosc/api/file/readFileByPath",
    method: "post",
    params: { filePath },
  });
}
